import { render, staticRenderFns } from "./userNotice.vue?vue&type=template&id=5f83969d&scoped=true&"
import script from "./userNotice.vue?vue&type=script&lang=js&"
export * from "./userNotice.vue?vue&type=script&lang=js&"
import style0 from "./userNotice.vue?vue&type=style&index=0&id=5f83969d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83969d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\胶己人\\jjr_store_reservation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f83969d')) {
      api.createRecord('5f83969d', component.options)
    } else {
      api.reload('5f83969d', component.options)
    }
    module.hot.accept("./userNotice.vue?vue&type=template&id=5f83969d&scoped=true&", function () {
      api.rerender('5f83969d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userNotice.vue"
export default component.exports